import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/manrope';
import ComingSoon from './ComingSoon';
import './coming-soon.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ComingSoon />
  </React.StrictMode>,
);
